import React from "react";
import "../Style/releaseNote.css";
const ReleaseBanner = () => {
  return (
    <div className=" flex justify-center items-center text-white z-50 release-banner">
      <h1 className=" text-white text-[24px] mt-14 md:text-[40px] font-semibold leading-[90px]">
        Release Note
      </h1>
    </div>
  );
};

export default ReleaseBanner;
